class SharedStorageAgentInterface {
    get = async (key=null) => {
        throw new Error("get method not implemented")
    }

    set = async (key, value) => {
        throw new Error("set method not implemented")
    }

    reset = async (key=null) => {
        throw new Error("reset method not implemented")
    }
}

export default SharedStorageAgentInterface;